import axios from 'axios';

export async function enableGoogleMfa() {
  const {data} = await axios.post(`/api/?entity=twoFactorAuthentication&action=google2faEnable`);
  return data.data;
}
